import type { ReactNode } from "react";

interface ComingSoonProps {
    title: string;
    text: ReactNode;
}

const ComingSoon = ({ title, text }: ComingSoonProps) => { 
    return (
        <div className="coming-soon">
            <h1>Coming Soon</h1>
            <h2>{title}</h2>
            <div className="coming-soon__content">
                {text}
            </div>
        </div>
    );
};

export default ComingSoon;
